export function addParamToTpl (template, selector, attribute, value) {
    if (!template) {
        return template
    }
    let container = document.createElement('div')
    container.innerHTML = template
    let changeNodes = container.querySelectorAll(selector)

    if (changeNodes.length) {
        Array.from(changeNodes).forEach(node => {
            node.setAttribute(attribute, value)
        })
    }

    return container.innerHTML
}
